import { render, staticRenderFns } from "./NoteAndProductListModal.vue?vue&type=template&id=f4b642b6&scoped=true"
import script from "./NoteAndProductListModal.vue?vue&type=script&lang=js"
export * from "./NoteAndProductListModal.vue?vue&type=script&lang=js"
import style0 from "./NoteAndProductListModal.vue?vue&type=style&index=0&id=f4b642b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b642b6",
  null
  
)

export default component.exports